import React, { useEffect, useState } from "react";
import {
  MainContentWrapper,
  Header,
  ErrorBoundary,
} from "apm/components/common";
import { Accordion } from "react-bootstrap";
import TableUsers from "./TableUsers";
import { Box } from "@mui/material";
import HTMLRenderer from "./HTMLRenderer";
import "./SpiEmailDisapatcher.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getEmailDetails, approveSpiEmail } from "apm/api/spi_email_dispatcher";
import { toast } from "react-hot-toast";
import DailyReportSkeleton from "../reports/daily-report/DailyReportComponents/DailyReportSkeleton";
import SpiEmailMetaData from "./SpiEmailMetaData";

export default function SpiEmailDispatcher() {
  const initialData = {
    email_body: "",
    user_data: [],
    notification_status: "",
    approver_username: "",
    approved_on: "",
    slug: "",
  };
  const [formApiStatus, setFormApiStatus] = React.useState("running");
  const navigate = useNavigate();

  const location = useLocation();
  const search = location.search;
  const queryParams = new URLSearchParams(search);
  const session = queryParams.get("session");
  const { projectId, subProjectId, template_id } = useParams();
  const [notificationData, setNotificationData] = useState(initialData);
  const [isLoaded, setIsLoaded] = useState(false);

  const EmailProcess = (status: string) => {
    setFormApiStatus("running");
    approveSpiEmail(subProjectId, template_id, session, status)
      .then((result: any) => {
        if (result.status_code == 200) {
          toast.success(result.message);
          setNotificationData((prevState) => ({
            ...prevState,
            ...result.detail,
          }));
        } else {
          toast.error(result.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.detail ?? "An error has occurred!");
      })
      .finally(() => {
        setFormApiStatus("");
      });
  };

  useEffect(() => {
    getEmailDetails(subProjectId, template_id, session)
      .then((result: any) => {
        setNotificationData(result.detail);
      })
      .catch((error) => {
        toast.error(error.response?.data?.detail ?? "An error has occurred!");
      })
      .finally(() => {
        setIsLoaded(true);
        setFormApiStatus("");
      });
  }, []);

  return (
    <>
      <Header />
      <MainContentWrapper bgColor="#f8fafc">
        <div className="page__container" style={{ zIndex: 10 }}>
          <div className="page-head mb-4">
            <div className="d-flex align-items-end justify-content-between">
              <div className="col-lg">
                <h4 className="font-size-32pt mb-2 font-weight-bolder">
                  SPI Email
                </h4>
              </div>
              <div className="col-lg-auto">
                <div className="col-lg">
                  <SpiEmailMetaData
                    status={notificationData.notification_status}
                    approved_on={notificationData.approved_on}
                    approved_by={notificationData.approver_username}
                    formApiStatus={formApiStatus}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Accordion
          className="accordion__nostyle"
          defaultActiveKey={["0", "1", "2"]}
          alwaysOpen
        >
          <Accordion.Item eventKey="0">
            <Accordion.Header>Distribution Users Details</Accordion.Header>
            <Accordion.Body>
              <ErrorBoundary>
                {isLoaded ? (
                  <TableUsers user_data={notificationData.user_data} />
                ) : (
                  <DailyReportSkeleton />
                )}
              </ErrorBoundary>
              <div className="mt-1" style={{ minHeight: "32px" }}></div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>Email Content</Accordion.Header>
            {/* <Accordion.Body className="html-content"  style={{ maxHeight: '45vh', overflowY: 'auto' }}> */}
            <Accordion.Body
              className="html-content"
              style={{ background: "#f8fafc" }}
            >
              <ErrorBoundary>
                {isLoaded ? (
                  <HTMLRenderer html_content={notificationData.email_body} />
                ) : (
                  <DailyReportSkeleton />
                )}
              </ErrorBoundary>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" className="mt-5">
            <Accordion.Body>
              <ErrorBoundary>
                <Box component="span" sx={{ display: "block" }}>
                  <div className="d-flex align-items-end justify-content-between button-list">
                    {isLoaded && (
                      <button
                        disabled={formApiStatus === "running"}
                        onClick={() =>
                          navigate(
                            `/projects/${projectId}/data-entry/working-form/sub-project/${subProjectId}/${notificationData.slug}/${template_id}`,
                          )
                        }
                        className="btn btn-primary"
                      >
                        View Form
                      </button>
                    )}
                    {isLoaded &&
                      notificationData.notification_status == "Pending" && (
                        <div className="button-list">
                          <button
                            disabled={formApiStatus === "running"}
                            type="button"
                            onClick={() => EmailProcess("reject")}
                            className="btn btn-danger"
                          >
                            <i className="bi bi-x-lg" /> Reject
                          </button>
                          <button
                            disabled={formApiStatus === "running"}
                            type="submit"
                            onClick={() => EmailProcess("approve")}
                            className="btn btn-primary "
                          >
                            <i className="bi bi-send" /> Approve
                          </button>
                        </div>
                      )}
                  </div>
                </Box>
              </ErrorBoundary>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </MainContentWrapper>
    </>
  );
}
